import onResize from '../helpers/on-resize';
import transitionEnd from '../helpers/transition-end';
import { viewport } from '../helpers/variables';
import { $ } from '../helpers/query-selector';

const navToggle = $('.js-nav-toggle');
const navWrapper = $('.js-nav-mobile');
const navIcon = $('.js-nav-icon');
const navIconActiveClass = 'c-nav-icon--active';
const navWrapperActiveClass = 'l-nav__wrapper--active';
const navWrapperAnimClass = 'l-nav__wrapper--anim';
let navVisible = false;

function showNav() {
  navVisible = true;

  navToggle.setAttribute('aria-expanded', 'true');
  navIcon.classList.add(navIconActiveClass);

  navWrapper.classList.add(navWrapperActiveClass);
  navWrapper.classList.add(navWrapperAnimClass);
}

async function hideNav() {
  navVisible = false;

  navToggle.setAttribute('aria-expanded', 'false');
  navIcon.classList.remove(navIconActiveClass);

  navWrapper.classList.remove(navWrapperActiveClass);
  await transitionEnd(navWrapper, 'opacity');
  navWrapper.classList.remove(navWrapperAnimClass);
}

export default () => {
  navToggle.addEventListener('click', e => {
    navVisible ? hideNav() : showNav();
  });

  // Close nav if link is clicked
  navWrapper.addEventListener('click', e => {
    if (navVisible && e.target.tagName === 'A') hideNav();
  });

  // Close nav on resize
  onResize(
    () => {
      if (!navVisible || !viewport.l.matches) return;

      hideNav();
    },
    { horizontalOnly: true }
  );
};
